"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/opt/build/repo/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var events_1 = require("events");

var logger_1 = require("./logger");

var configuration_1 = require("./configuration");

var twilsock_1 = require("./twilsock");

var packetinterface_1 = require("./packetinterface");

var websocketchannel_1 = require("./websocketchannel");

var registrations_1 = require("./services/registrations");

var upstream_1 = require("./services/upstream");

var deferred_1 = require("./deferred");

var index_1 = require("./index");

var offlinestorage_1 = require("./offlinestorage");

var tokenStorage_1 = require("./tokenStorage");
/**
 * @alias Twilsock
 * @classdesc Client library for the Twilsock service
 * It allows to recevie service-generated updates as well as bi-directional transport
 * @fires Twilsock#message
 * @fires Twilsock#connected
 * @fires Twilsock#disconnected
 * @fires Twilsock#tokenAboutToExpire
 * @fires Twilsock#stateChanged
 * @fires Twilsock#connectionError
 */


var TwilsockClient =
/*#__PURE__*/
function (_events_1$EventEmitte) {
  _inherits(TwilsockClient, _events_1$EventEmitte);

  /**
   * @param {string} token Twilio access token
   * @param {string} productId Product identifier. Should be the same as a grant name in token
   */
  function TwilsockClient(token, productId) {
    var _this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, TwilsockClient);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TwilsockClient).call(this));
    _this.offlineStorageDeferred = new deferred_1.Deferred();
    options.continuationToken = options.continuationToken ? options.continuationToken : tokenStorage_1.TokenStorage.getStoredToken(productId);
    var config = _this.config = new configuration_1.Configuration(token, productId, options);
    logger_1.log.setLevel(config.logLevel);
    var websocket = new websocketchannel_1.WebSocketChannel(config.url);
    var transport = options.transport ? options.transport : new packetinterface_1.PacketInterface(websocket, config);
    _this.channel = options.channel ? options.channel : new twilsock_1.TwilsockImpl(websocket, transport, config);
    _this.registrations = options.registrations ? options.registrations : new registrations_1.Registrations(transport);
    _this.upstream = new upstream_1.Upstream(transport, _this.channel, config);

    _this.registrations.on('registered', function (id) {
      return _this.emit('registered', id);
    });

    _this.channel.on('message', function (type, message) {
      return setTimeout(function () {
        return _this.emit('message', type, message);
      }, 0);
    });

    _this.channel.on('stateChanged', function (state) {
      return setTimeout(function () {
        return _this.emit('stateChanged', state);
      }, 0);
    });

    _this.channel.on('connectionError', function (connectionError) {
      return setTimeout(function () {
        return _this.emit('connectionError', connectionError);
      }, 0);
    });

    _this.channel.on('tokenAboutToExpire', function () {
      return setTimeout(function () {
        return _this.emit('tokenAboutToExpire');
      }, 0);
    });

    _this.channel.on('tokenExpired', function () {
      return setTimeout(function () {
        return _this.emit('tokenExpired');
      }, 0);
    });

    _this.channel.on('connected', function () {
      return _this.registrations.updateRegistrations();
    });

    _this.channel.on('connected', function () {
      return _this.upstream.sendPendingMessages();
    });

    _this.channel.on('connected', function () {
      return setTimeout(function () {
        return _this.emit('connected');
      }, 0);
    });

    _this.channel.on('initialized', function (initReply) {
      _this.handleStorageId(productId, initReply);

      tokenStorage_1.TokenStorage.storeToken(initReply.continuationToken, productId);
      setTimeout(function () {
        return _this.emit('initialized', initReply);
      }, 0);
    });

    _this.channel.on('disconnected', function () {
      return setTimeout(function () {
        return _this.emit('disconnected');
      }, 0);
    });

    _this.channel.on('disconnected', function () {
      return _this.upstream.rejectPendingMessages();
    });

    _this.channel.on('disconnected', function () {
      return _this.offlineStorageDeferred.fail(new index_1.TwilsockError('Client disconnected'));
    });

    _this.offlineStorageDeferred.promise["catch"](function () {});

    return _this;
  }

  _createClass(TwilsockClient, [{
    key: "emit",
    value: function emit(event) {
      var _get2;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      logger_1.log.debug("Emitting ".concat(event.toString(), "(").concat(args.map(function (a) {
        return JSON.stringify(a);
      }).join(', '), ")"));
      return (_get2 = _get(_getPrototypeOf(TwilsockClient.prototype), "emit", this)).call.apply(_get2, [this, event].concat(args));
    }
  }, {
    key: "handleStorageId",
    value: function handleStorageId(productId, initReply) {
      if (!initReply.offlineStorage) {
        this.offlineStorageDeferred.fail(new index_1.TwilsockError('No offline storage id'));
      } else if (initReply.offlineStorage.hasOwnProperty(productId)) {
        try {
          this.offlineStorageDeferred.set(offlinestorage_1.OfflineProductStorage.create(initReply.offlineStorage[productId]));
          logger_1.log.debug("Offline storage for '".concat(productId, "' product: ").concat(JSON.stringify(initReply.offlineStorage[productId]), "."));
        } catch (e) {
          this.offlineStorageDeferred.fail(new index_1.TwilsockError("Failed to parse offline storage for ".concat(productId, " ").concat(JSON.stringify(initReply.offlineStorage[productId]), ". ").concat(e, ".")));
        }
      } else {
        this.offlineStorageDeferred.fail(new index_1.TwilsockError("No offline storage id for '".concat(productId, "' product: ").concat(JSON.stringify(initReply.offlineStorage))));
      }
    }
    /**
     * Get offline storage ID
     * @returns {Promise<OfflineProductStorage>}
     */

  }, {
    key: "storageId",
    value: function storageId() {
      return this.offlineStorageDeferred.promise;
    }
    /**
     * Indicates if twilsock is connected now
     * @returns {Boolean}
     */

  }, {
    key: "updateToken",

    /**
     * Update token
     * @param {String} token
     * @returns {Promise<void>}
     */
    value: function () {
      var _updateToken = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(token) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                logger_1.log.trace("updating token '".concat(token, "'"));

                if (!(this.config.token === token)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                this.config.updateToken(token);
                return _context.abrupt("return", this.channel.updateToken(token));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateToken(_x) {
        return _updateToken.apply(this, arguments);
      }

      return updateToken;
    }()
    /**
     * Updates notification context.
     * This method shouldn't be used anyone except twilio notifications library
     * @param contextId id of notification context
     * @param context value of notification context
     * @private
     */

  }, {
    key: "setNotificationsContext",
    value: function setNotificationsContext(contextId, context) {
      this.registrations.setNotificationsContext(contextId, context);
    }
    /**
     * Remove notification context.
     * This method shouldn't be used anyone except twilio notifications library
     * @param contextId id of notification context
     * @private
     */

  }, {
    key: "removeNotificationsContext",
    value: function removeNotificationsContext(contextId) {
      this.registrations.removeNotificationsContext(contextId);
    }
    /**
     * Connect to the server
     * @fires Twilsock#connected
     * @public
     * @returns {Promise<void>}
     */

  }, {
    key: "connect",
    value: function connect() {
      return this.channel.connect();
    }
    /**
     * Disconnect from the server
     * @fires Twilsock#disconnected
     * @public
     * @returns {Promise<void>}
     */

  }, {
    key: "disconnect",
    value: function disconnect() {
      return this.channel.disconnect();
    }
    /**
     * Get HTTP request to upstream service
     * @param {string} url Upstream service url
     * @param {headers} headers Set of custom headers
     * @returns {Promise}
     */

  }, {
    key: "get",
    value: function get(url, headers) {
      return this.upstream.send('GET', url, headers);
    }
    /**
     * Post HTTP request to upstream service
     * @param {string} url Upstream service url
     * @param {headers} headers Set of custom headers
     * @param {body} body Body to send
     * @returns {Promise}
     */

  }, {
    key: "post",
    value: function post(url, headers, body) {
      return this.upstream.send('POST', url, headers, body);
    }
    /**
     * Put HTTP request to upstream service
     * @param {string} url Upstream service url
     * @param {headers} headers Set of custom headers
     * @param {body} body Body to send
     * @returns {Promise}
     */

  }, {
    key: "put",
    value: function put(url, headers, body) {
      return this.upstream.send('PUT', url, headers, body);
    }
    /**
     * Delete HTTP request to upstream service
     * @param {string} url Upstream service url
     * @param {headers} headers Set of custom headers
     * @returns {Promise}
     */

  }, {
    key: "delete",
    value: function _delete(url, headers) {
      return this.upstream.send('DELETE', url, headers);
    }
  }, {
    key: "isConnected",
    get: function get() {
      return this.channel.isConnected;
    }
    /**
     * Current state
     * @returns {String}
     */

  }, {
    key: "state",
    get: function get() {
      return this.channel.state;
    }
  }]);

  return TwilsockClient;
}(events_1.EventEmitter);

exports.TwilsockClient = TwilsockClient;
exports.Twilsock = TwilsockClient;
/**
 * Twilsock destination address descriptor
 * @typedef {Object} Twilsock#Address
 * @property {String} method - HTTP method. (POST, PUT, etc)
 * @property {String} host - host name without path. (e.g. my.company.com)
 * @property {String} path - path on the host (e.g. /my/app/to/call.php)
 */

/**
 * Twilsock upstream message
 * @typedef {Object} Twilsock#Message
 * @property {Twilsock#Address} to - destination address
 * @property {Object} headers - HTTP headers
 * @property {Object} body - Body
 */

/**
 * Fired when new message received
 * @param {Twilsock#Message} message
 * @event Twilsock#message
 */

/**
 * Fired when socket connected
 * @param {String} URI of endpoint
 * @event Twilsock#connected
 */

/**
 * Fired when socket disconnected
 * @event Twilsock#disconnected
 */

/**
 * Fired when token is about to expire and should be updated
 * @event Twilsock#tokenAboutToExpire
 */

/**
* Fired when socket connected
* @param {('connecting'|'connected'|'rejected'|'disconnecting'|'disconnected')} state - general twilsock state
* @event Twilsock#stateChanged
*/

/**
 * Fired when connection is interrupted by unexpected reason
 * @type {Object}
 * @property {Boolean} terminal - twilsock will stop connection attempts
 * @property {String} message - root cause
 * @property {Number} [httpStatusCode] - http status code if available
 * @property {Number} [errorCode] - Twilio public error code if available
 * @event Twilsock#connectionError
 */